module.exports = __webpack_public_path__ + "static/media/hobby-heap.66af3f3a.md";